var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"gd-background"},[_c('router-view',{staticClass:"mb-5"}),_c('FooterApps')],1)}
var staticRenderFns = []

export { render, staticRenderFns }